import React from "react";
import { Container, Typography, Box, IconButton } from "@mui/material";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import { IBlog } from "../IBlog";
import { StyledBlogFooter } from "./StyledBlogFooter";
import { trackUrlInteraction } from "../../common/hooks";

export const BlogFooter = ({ blog }: { blog: IBlog }) => {
  const currentUrl = typeof window !== "undefined" 
    ? window.location.href 
    : "";
  
  const shareTitle = blog.title || "Check out this blog post";
  
  const shareUrls = {
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
    email: `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(currentUrl)}`,
  };

  const handleShare = (platform: "linkedin" | "facebook" | "email") => {
    const url = shareUrls[platform];
    trackUrlInteraction(url, `blog_share_${platform}`);
    if (platform === "email") {
      window.location.href = url;
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <StyledBlogFooter>
      <Container>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, padding: "40px 0" }}>
          <Typography 
            variant="h6" 
            sx={{ 
              color: "#0F2F4B", 
              fontSize: "18px", 
              fontWeight: "600",
            }}
          >
            Share this
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <IconButton
              onClick={() => handleShare("linkedin")}
              aria-label="Share on LinkedIn"
              sx={{
                color: "#fff",
                backgroundColor: "#0077B5",
                width: 40,
                height: 40,
                "&:hover": {
                  backgroundColor: "#005885",
                },
              }}
            >
              <LinkedInIcon sx={{ fontSize: 28 }} />
            </IconButton>
            <IconButton
              onClick={() => handleShare("facebook")}
              aria-label="Share on Facebook"
              sx={{
                color: "#fff",
                backgroundColor: "#1877F2",
                width: 40,
                height: 40,
                "&:hover": {
                  backgroundColor: "#1464D0",
                },
              }}
            >
              <FacebookIcon sx={{ fontSize: 28 }} />
            </IconButton>
            <IconButton
              onClick={() => handleShare("email")}
              aria-label="Share via Email"
              sx={{
                color: "#fff",
                backgroundColor: "#0F2F4B",
                width: 40,
                height: 40,
                "&:hover": {
                  backgroundColor: "#0A1F33",
                },
              }}
            >
              <EmailIcon sx={{ fontSize: 28 }} />
            </IconButton>
          </Box>
        </Box>
      </Container>
    </StyledBlogFooter>
  );
};

